'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z' });

var InsertDriveFile = function InsertDriveFile(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

InsertDriveFile = (0, _pure2.default)(InsertDriveFile);
InsertDriveFile.muiName = 'SvgIcon';

exports.default = InsertDriveFile;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/InsertDriveFile.js
// module id = 2510
// module chunks = 0